import { useQuery } from "@tanstack/react-query";
import { useContext, useMemo } from "react";
import { RefetchIntervals } from "../../contants/RefetchIntervals";
import { ImageContext } from "../../context/imageContext";
import { OmroepContext, OmroepContextType } from "../../context/omroepContext";
import { fetchOmroep } from "../../functions/fetchFunctions/fetchOmroep";
import { TvChannelOverview } from "../tvChannelOverview/tvChannelOverview";

interface OmroepContextProviderProps {
  children: React.ReactNode;
  omroep: string;
}

export function OmroepContextProvider({ children , omroep}: OmroepContextProviderProps) {
  const imageContext = useContext(ImageContext);
  const omroepFetchedData = useQuery({
    queryKey: ["omroepData", omroep],
    queryFn: async () => fetchOmroep(omroep ?? ""),
    refetchInterval: RefetchIntervals.omroep
  });
  const omroepLogo = useQuery({
    queryKey: ["omroepLogo", omroepFetchedData.data?.acf.kabelkrant_logo],
    queryFn: async () => imageContext.getImageUrl(omroepFetchedData.data?.acf.kabelkrant_logo || 0),
    enabled: omroepFetchedData.data != null
  });
  const omroepTitleBarLogo = useQuery({
    queryKey: ["omroepTitleBarLogo", omroepFetchedData.data?.acf.kabelkrant_title_bar],
    queryFn: async () => imageContext.getImageUrl(omroepFetchedData.data?.acf.kabelkrant_title_bar || 0),
    enabled: omroepFetchedData.data != null
  });

  const omroepData: OmroepContextType = useMemo(
    () => ({
      logo: omroepLogo.data || "",
      titleBarLogo: omroepTitleBarLogo.data || "",
      accentColor: omroepFetchedData.data?.acf.kabelkrant_accent_color || "#000000",
      slides: omroepFetchedData.data?.acf.kabelkrant_dia || []
    }),
    [omroepFetchedData, omroepLogo, omroepTitleBarLogo.data]
  );

  if (omroepFetchedData.data == null && omroepFetchedData.isFetched) {
    return <TvChannelOverview notFoundComponent={"Omroep is niet gevonden, misschien bedoel je 1 van deze omroepen"} />;
  }

  return (
    <div style={{ "--color-accent": omroepData.accentColor } as never}>
      <OmroepContext.Provider value={omroepData}>{children}</OmroepContext.Provider>
    </div>
  );
}
